import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faUserPlus,
  faEnvelope,
  faLock,
  faPhone,
  faEye,
  faEyeSlash,
  faUserShield,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { FaTimes } from "react-icons/fa";

const CreateNewSubAdmin = () => {
  const [showAddModal, setShowAddModal] = useState(false);
  // const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    mobileNumber: "",
    assignedSections: "",
  });

  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showOtpFields, setShowOtpFields] = useState(false);
  const [admins, setAdmins] = useState([]);
  const [otpData, setOtpData] = useState({
    otpEmail: "",
  });
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [accessFields, setAccessFields] = useState([
    { path: "" }, // Initialize with an object
  ]);

  useEffect(() => {
    fetchAllAdmins();
  }, []);

  const handleFieldChange = (index, key, value) => {
    const updatedFields = [...accessFields];
    updatedFields[index][key] = value;
    setAccessFields(updatedFields);
  };

  const addField = () => {
    setAccessFields([...accessFields, { path: "" }]);
  };

  const removeField = (index) => {
    const updatedFields = accessFields.filter((_, idx) => idx !== index);
    setAccessFields(updatedFields);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setError("");
  };

  const validateEmail = (email) => {
    // Simple email regex
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const validatePhone = (phone) => {
    // Example: 10 digit number
    return /^\d{10}$/.test(phone);
  };

  const validatePassword = (password) => {
    // At least 8 chars, one uppercase, one lowercase, one number
    return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/.test(password);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!validateEmail(formData.email)) {
      setError("Please enter a valid email address.");
      return;
    }
    if (!validatePhone(formData.mobileNumber)) {
      setError("Please enter a valid 10-digit mobile number.");
      return;
    }

    if (!formData.assignedSections) {
      setError("Please enter assigned sections.");
      return;
    }
    if (!validatePassword(formData.password)) {
      setError(
        "Password must be at least 8 characters and include uppercase, lowercase, and a number."
      );
      return;
    }
    if (formData.password !== formData.confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    setIsLoading(true);
    try {
      const data = {
        name: formData.name,
        email: formData.email,
        mobileNumber: formData.mobileNumber,
        password: formData.password,
        confirmPassword: formData.confirmPassword,
        assignedSections: formData.assignedSections,
        accessPaths: accessFields.map((f) => f.path),
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/superadmin/create/subadmin`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      console.log("Registration send otp Response:", response);

      // Always show OTP fields after successfull form submission
      setShowOtpFields(true);
      toast.success("OTP sent to email. Please verify to complete registration.");
    } catch (error) {
      setError(
        error.response?.data?.message ||
        "Registration failed. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleOtpChange = (e) => {
    setOtpData({
      ...otpData,
      [e.target.name]: e.target.value,
    });
  };

  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation(); // optional but safe
    console.log("OTP Data:", otpData);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/register/verify/otp`,
        {
          email: formData.email,
          mobileNumber: formData.mobileNumber,
          emailOtp: otpData.otpEmail,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      console.log("OTP verify Response:", response);

      if (response.status === 201) {
        toast.success("SubAdmin registered successfully.");
        setShowOtpFields(false);
        fetchAllAdmins();
        setShowAddModal(false);
        // Reload after short delay to allow toast to show
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else if (response.status === 500) {
        toast.error("Internal Server Error. Please try again later.");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "OTP verification failed");
    }
  };


  //get all admins  from backend
  const fetchAllAdmins = async () => {
    console.log("Fetching all admins...");
    setIsLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/super/admin/get/all/admins`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      console.log("All Admins Response:", response);


      setAdmins(response.data.data);
    } catch (error) {
      setError(
        error.response?.data?.message || "Failed to fetch admins."
      );
    } finally {
      setIsLoading(false);
    }


  };


  return (
    <div className="p-4">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-800">Admin Management</h1>
        <button
          onClick={() => setShowAddModal(true)}
          className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
        >
          <FontAwesomeIcon icon={faUserPlus} className="mr-2" />
          Add New Admin
        </button>
      </div>

      <div className="bg-white rounded-xl shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Name
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Role
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Email
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Phone
                </th>

              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {admins.map((admin) => (
                <tr key={admin.id}>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center">
                      <div className="h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center">
                        <FontAwesomeIcon icon={faUserShield} className="text-blue-600" />
                      </div>
                      <div className="ml-4">
                        <div className="text-sm font-medium text-gray-900">{admin.name}</div>

                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-purple-100 text-purple-800">
                      {admin.role}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${admin.email
                      }`}>
                      {admin.email}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {admin.mobileNumber}
                  </td>

                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Add Admin Modal */}
      {showAddModal && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-60 flex items-center justify-center transition-all duration-300 px-2 sm:px-4">
          <div className="bg-white rounded-2xl shadow-2xl p-4 sm:p-8 md:p-10 w-full max-w-lg relative border border-gray-200 animate-fadeIn mx-auto overflow-y-auto max-h-[95vh]">
            <button
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-400 rounded-full transition-colors duration-200"
              onClick={() => setShowAddModal(false)}
              aria-label="Close"
            >
              <FaTimes className="w-5 h-5" />
            </button>
            <h2 className="text-2xl font-extrabold mb-6 text-center text-gray-800 tracking-tight">
              Add New Admin
            </h2>
            <form onSubmit={handleSubmit} className="space-y-10">
              {error && (
                <motion.div
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  className="bg-red-100 text-red-600 p-3 rounded-lg text-sm text-center shadow-sm border border-red-200"
                >
                  {error}
                </motion.div>
              )}

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                    <FontAwesomeIcon icon={faUser} className="text-gray-400" />
                  </div>
                  <input
                    type="text"
                    name="name"
                    required
                    className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-400 transition-all duration-200 bg-gray-50 placeholder-gray-400 shadow-sm"
                    placeholder="Full Name"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>

                <div className="relative">
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                    <FontAwesomeIcon
                      icon={faEnvelope}
                      className="text-gray-400"
                    />
                  </div>
                  <input
                    type="email"
                    name="email"
                    required
                    className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-400 transition-all duration-200 bg-gray-50 placeholder-gray-400 shadow-sm"
                    placeholder="Email Address"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>

                <div className="relative">
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                    <FontAwesomeIcon icon={faPhone} className="text-gray-400" />
                  </div>
                  <input
                    type="tel"
                    name="mobileNumber"
                    required
                    className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-400 transition-all duration-200 bg-gray-50 placeholder-gray-400 shadow-sm"
                    placeholder="Mobile Number"
                    value={formData.mobileNumber}
                    onChange={handleChange}
                  />
                </div>

                {/* //assignedSections */}
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                    <FontAwesomeIcon icon={faUsers} className="text-gray-400" />
                  </div>
                  <input
                    type="text"
                    name="assignedSections"
                    required
                    className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-400 transition-all duration-200 bg-gray-50 placeholder-gray-400 shadow-sm"
                    placeholder="Assigned Section"
                    value={formData.assignedSections}
                    onChange={handleChange}
                  />
                </div>

                <div className="relative">
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                    <FontAwesomeIcon icon={faLock} className="text-gray-400" />
                  </div>
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    required
                    className="w-full pl-10 pr-10 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-400 transition-all duration-200 bg-gray-50 placeholder-gray-400 shadow-sm"
                    placeholder="Password"
                    value={formData.password}
                    onChange={handleChange}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute inset-y-0 right-0 flex items-center pr-3 focus:outline-none"
                  >
                    <FontAwesomeIcon
                      icon={showPassword ? faEyeSlash : faEye}
                      className="text-gray-400"
                    />
                  </button>
                </div>

                <div className="relative">
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                    <FontAwesomeIcon icon={faLock} className="text-gray-400" />
                  </div>
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    name="confirmPassword"
                    required
                    className="w-full pl-10 pr-10 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-400 transition-all duration-200 bg-gray-50 placeholder-gray-400 shadow-sm"
                    placeholder="Confirm Password"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                  />
                  <button
                    type="button"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    className="absolute inset-y-0 right-0 flex items-center pr-3 focus:outline-none"
                  >
                    <FontAwesomeIcon
                      icon={showConfirmPassword ? faEyeSlash : faEye}
                      className="text-gray-400"
                    />
                  </button>
                </div>
              </div>

              <button
                type="button"
                onClick={addField}
                className="mt-2 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
              >
                Add More
              </button>

              {accessFields.map((field, idx) => (
                <div key={idx} className="flex flex-col sm:flex-row items-center gap-2 mt-2 w-full">
                  <input
                    type="text"
                    placeholder="Access Field Path"
                    value={field.path}
                    onChange={(e) =>
                      handleFieldChange(idx, "path", e.target.value)
                    }
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                  />

                  {accessFields.length > 1 && (
                    <button
                      type="button"
                      onClick={() => removeField(idx)}
                      className="text-red-500 text-xl font-bold px-2"
                      title="Remove"
                    >
                      &times;
                    </button>
                  )}
                </div>
              ))}

              <button
                type="submit"
                disabled={isLoading}
                className="w-full py-3 px-4 border border-transparent rounded-lg text-white bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 flex items-center justify-center space-x-2 shadow-lg transition-all duration-200 disabled:opacity-60 disabled:cursor-not-allowed"
              >
                {isLoading ? (
                  <motion.div
                    animate={{ rotate: 360 }}
                    transition={{
                      duration: 1,
                      repeat: Infinity,
                      ease: "linear",
                    }}
                    className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"
                  />
                ) : (
                  <>
                    <span>Create SubAdmin Account</span>
                    <FontAwesomeIcon icon={faUserShield} />
                  </>
                )}
              </button>
              <p className="mt-4 text-center text-sm text-gray-500">
                Already have an admin account?{" "}
                <Link
                  to="/admin/login"
                  className="font-medium text-blue-600 hover:text-blue-500 underline underline-offset-2"
                >
                  Sign in
                </Link>
              </p>
            </form>
            {showOtpFields && (
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  console.log("Form Submitted");
                  handleOtpSubmit(e);
                }}
                className="space-y-4 mt-6"
              >
                <div className="grid grid-cols-1 gap-4">
                  <input
                    type="text"
                    name="otpEmail"
                    placeholder="OTP sent to Email"
                    value={otpData.otpEmail}
                    onChange={handleOtpChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-2 sm:mb-0"
                    required
                  />
                </div>
                <button
                  type="submit"
                  className="w-full py-3 px-4 border border-transparent rounded-lg text-white bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700"
                >
                  Verify OTP
                </button>
              </form>
            )}
          </div>
        </div>
      )}


    </div>
  );
};

export default CreateNewSubAdmin;
